import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PopUp from '../../../../Shared/Popup/PopUp';
import Config from '../../../../../Config';
import { prepareSameWindowUrlWithNavigateTo } from '../../../../../utilities/StringHelpers/StringHelpers';
import { setInternetExistingInternetChoicePopup } from '../../saleJetBlockSlice';
import { createWorkOrder } from '../../saleBlockAsyncThunk';
import { getInternetProducts } from '../../../ProblemDomainSelectionBlock/problemDomainAsyncThunk';
import { showAppLoader, hideAppLoader } from '../../../../Shared/Loader/LoaderSlice';
import SuccessCheckIcon from '../InternetIdentitySuccessPopup/SuccessCheckIcon';
import './internetExistingInternetChoicePopup.scss';

const CHOICE = {
  REPLACE: 'replace',
  NEW_ADDRESS: 'newAddress',
};

const STEP = {
  CHOICE: 'choice',
  CALLBACK: 'callback',
};

const getProductAddress = (product) => {
  const address = product?.address;
  if (!address) {
    return '';
  }
  if (typeof address === 'string') {
    return address.trim();
  }
  return String(address.fullAddress || address.FullAddress || '').trim();
};

const InternetExistingInternetChoicePopup = (props) => {
  const { isDisplay } = props.internetExistingInternetChoicePopup || {};
  const [selectedChoice, setSelectedChoice] = useState(CHOICE.NEW_ADDRESS);
  const [step, setStep] = useState(STEP.CHOICE);
  const [internetProduct, setInternetProduct] = useState(null);

  useEffect(() => {
    if (!isDisplay) {
      return;
    }
    setSelectedChoice(CHOICE.NEW_ADDRESS);
    setStep(STEP.CHOICE);
    let cancelled = false;
    const loadInternetProduct = async () => {
      props.showAppLoader();
      try {
        const products = await getInternetProducts();
        if (!cancelled) {
          setInternetProduct(products[0] || null);
        }
      } finally {
        if (!cancelled) {
          props.hideAppLoader();
        }
      }
    };
    loadInternetProduct();
    return () => {
      cancelled = true;
      props.hideAppLoader();
    };
  }, [isDisplay]);

  const handleClose = () => {
    setStep(STEP.CHOICE);
    props.setInternetExistingInternetChoicePopup({ isDisplay: false });
  };

  const handleSubmit = async () => {
    const description =
      selectedChoice === CHOICE.REPLACE
        ? 'לקוח עם חבילת אינטרנט קיימת - ביקש החלפת חבילה נוכחית'
        : 'לקוח עם חבילת אינטרנט קיימת - ביקש הוספת סיבים לכתובת חדשה';

    await props.createWorkOrder({
      id: '75',
      description,
    });
    setStep(STEP.CALLBACK);
  };

  const handleBackToPersonalArea = () => {
    handleClose();
    prepareSameWindowUrlWithNavigateTo(Config.lobbyUrl);
  };

  const packageName = internetProduct?.description || internetProduct?.name || '';
  const addressText = getProductAddress(internetProduct);
  const callbackSubtitle =
    selectedChoice === CHOICE.REPLACE
      ? 'בקשתך להחלפת חבילה נוכחית בוצעה בהצלחה'
      : 'בקשתך להוספת סיבים לכתובת חדשה בוצעה בהצלחה';

  return (
    <PopUp
      className='internet-existing-internet-choice-popup'
      showPopUp={Boolean(isDisplay)}
      onClose={handleBackToPersonalArea}
      preventWrapperClose={true}
    >
      <div className='internet-existing-internet-choice-popup__content'>
        {step === STEP.CALLBACK ? (
          <>
            <SuccessCheckIcon />
            <h2 className='internet-existing-internet-choice-popup__title'>
              נציג יצור איתך קשר להמשך הטיפול
            </h2>
            <p className='internet-existing-internet-choice-popup__subtitle'>
              {callbackSubtitle}
            </p>
            <button
              type='button'
              className='internet-existing-internet-choice-popup__submit'
              onClick={handleBackToPersonalArea}
            >
              חזרה אל האזור האישי
            </button>
          </>
        ) : (
          <>
            <h2 className='internet-existing-internet-choice-popup__title'>
              זיהינו שיש לך חבילת אינטרנט קיימת
            </h2>
            <p className='internet-existing-internet-choice-popup__subtitle'>כיצד להתקדם?</p>

            <div className='internet-existing-internet-choice-popup__options'>
              <button
                type='button'
                className={`internet-existing-internet-choice-popup__option ${
                  selectedChoice === CHOICE.REPLACE ? 'is-selected' : ''
                }`}
                onClick={() => setSelectedChoice(CHOICE.REPLACE)}
              >
                <span className='internet-existing-internet-choice-popup__radio' aria-hidden='true' />
                <span className='internet-existing-internet-choice-popup__option-body'>
                  <span className='internet-existing-internet-choice-popup__option-title'>
                    החלפת חבילה נוכחית
                  </span>
                  {(packageName || addressText) && (
                    <span className='internet-existing-internet-choice-popup__option-meta'>
                      {packageName ? <span>{packageName}</span> : null}
                      {addressText ? <span>{addressText}</span> : null}
                    </span>
                  )}
                </span>
              </button>

              <button
                type='button'
                className={`internet-existing-internet-choice-popup__option ${
                  selectedChoice === CHOICE.NEW_ADDRESS ? 'is-selected' : ''
                }`}
                onClick={() => setSelectedChoice(CHOICE.NEW_ADDRESS)}
              >
                <span className='internet-existing-internet-choice-popup__radio' aria-hidden='true' />
                <span className='internet-existing-internet-choice-popup__option-body'>
                  <span className='internet-existing-internet-choice-popup__option-title'>
                    הוספת סיבים לכתובת חדשה
                  </span>
                </span>
              </button>
            </div>

            <button
              type='button'
              className='internet-existing-internet-choice-popup__submit'
              onClick={handleSubmit}
            >
              שנציג יחזור אלי
            </button>
          </>
        )}
      </div>
    </PopUp>
  );
};

const mapStateToProps = (state) => ({
  internetExistingInternetChoicePopup: state.saleJetBlock.internetExistingInternetChoicePopup,
});

const mapDispatchToProps = {
  setInternetExistingInternetChoicePopup,
  createWorkOrder,
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(InternetExistingInternetChoicePopup);
